"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSsnLast4Dto = instanceOfSsnLast4Dto;
exports.SsnLast4DtoFromJSON = SsnLast4DtoFromJSON;
exports.SsnLast4DtoFromJSONTyped = SsnLast4DtoFromJSONTyped;
exports.SsnLast4DtoToJSON = SsnLast4DtoToJSON;
exports.SsnLast4DtoToJSONTyped = SsnLast4DtoToJSONTyped;
/**
 * Check if a given object implements the SsnLast4Dto interface.
 */
function instanceOfSsnLast4Dto(value) {
    if (!('ssnLast4' in value) || value['ssnLast4'] === undefined)
        return false;
    return true;
}
function SsnLast4DtoFromJSON(json) {
    return SsnLast4DtoFromJSONTyped(json, false);
}
function SsnLast4DtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ssnLast4': json['ssnLast4'],
    };
}
function SsnLast4DtoToJSON(json) {
    return SsnLast4DtoToJSONTyped(json, false);
}
function SsnLast4DtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ssnLast4': value['ssnLast4'],
    };
}
//# sourceMappingURL=SsnLast4Dto.js.map